import * as React from "react";
import type { SVGProps } from "react";
const SvgAdddecIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="adddec_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M234.667 469.333a42.667 42.667 0 1 0 85.333 0V362.667h106.667a42.667 42.667 0 1 0 0-85.334H320V170.667a42.667 42.667 0 1 0-85.333 0v106.666H128a42.667 42.667 0 0 0 0 85.334h106.667v106.666zm320 320a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 832H597.333a42.667 42.667 0 0 1-42.666-42.667zm-353.835-8.832a42.667 42.667 0 1 0 60.33 60.331l537.003-537.003a42.667 42.667 0 0 0-60.33-60.33L200.832 780.5z"
    />
  </svg>
);
export default SvgAdddecIcon;
